"use client";

import { SideNav } from "@/components/SideNav";
import { TermsPage } from "@/components/TermsPage";

export default function TermsPageClient() {
  return (
    <>
      <SideNav />
      <TermsPage />
    </>
  );
}
